import React from "react"
import { Avatar, Theme, Typography, makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { getChatIcon, getSubtitle } from "../utils/chatUtil"
import UnreadCountBadge from "./UnreadCountBadge"

type Props = {
  title: string
  subtitle: string
  selected?: boolean
  unreadCount?: number
}

const ChatListItem = ({ title, subtitle, selected, unreadCount = 0 }: Props) => {
  const classes = useStyles()
  const { t } = useTranslation("chat")
  const isUnread = unreadCount > 0
  // `subtitle` is the raw chat type; getSubtitle turns it into the readable label.
  const ChatIcon = getChatIcon(subtitle)

  return (
    <div className={`${classes.root} ${selected ? classes.selected : ""}`}>
      <Avatar>
        <ChatIcon size={18} />
      </Avatar>

      <div className={classes.info}>
        <Typography className={isUnread ? classes.unreadText : undefined}>
          {title?.charAt(0).toUpperCase() + title?.slice(1)}
        </Typography>

        <Typography variant="body2" color="textSecondary">
          {getSubtitle(subtitle, t)}
        </Typography>
      </div>

      <UnreadCountBadge count={unreadCount} />
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    cursor: "pointer",

    "&:hover": {
      background: theme.palette.action.hover,
    },
  },

  selected: {
    background: theme.palette.action.selected,
  },

  info: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
  },

  unreadText: {
    fontWeight: 700,
  },
}))

export default ChatListItem
